/**
 * `tableConfig` d'un bloc Tableau tel que Puck peut le garder.
 *
 * Puck aplatit les props de chaque bloc (librairie `flat`, séparateur « . »)
 * puis les reconstruit : une clé d'objet contenant un point devient un chemin.
 * Or les réglages d'une cellule de ligne (`rowStyles[].cells`, cf.
 * shared/tables/tableRowStyle) sont rangés sous le libellé de la colonne —
 * « Dim. ☀️ » ressortait en `cells.Dim[" ☀️"]`, et le rendu ne la retrouvait
 * plus. Le point des clés est donc remplacé à l'écriture dans Puck, et rendu à
 * la lecture ; le format partagé avec le classique ne change pas.
 */

const DOT = '.';
// « One dot leader » : se lit comme un point, n'est pas le séparateur de `flat`.
const PUCK_SAFE_DOT = '․';

const mapCellKeys = (tableConfig, mapKey) => {
  if (!tableConfig?.rowStyles?.some((rule) => rule?.cells)) return tableConfig;
  return {
    ...tableConfig,
    rowStyles: tableConfig.rowStyles.map((rule) => (rule?.cells
      ? {
        ...rule,
        cells: Object.fromEntries(
          Object.entries(rule.cells).map(([key, entry]) => [mapKey(key), entry]),
        ),
      }
      : rule)),
  };
};

/** À écrire dans les props d'un bloc. */
export const toPuckTableConfig = (tableConfig) => (
  mapCellKeys(tableConfig, (key) => key.split(DOT).join(PUCK_SAFE_DOT))
);

/** Lu dans les props d'un bloc. */
export const fromPuckTableConfig = (tableConfig) => (
  mapCellKeys(tableConfig, (key) => key.split(PUCK_SAFE_DOT).join(DOT))
);
